import React, { useState, useEffect, useCallback } from 'react';
import { getAssignedTasks, taskAccepted, taskReject, handoverTask, getAllEmployees, startTask } from "../Services/masterService"

import TaskViewModal from '../components/TaskViewModal';
import TaskRejectModal from '../components/RejectModal';
import TaskCollectionModal from './TaskCollectionModal';
import HandoverTaskModal from './HandoverTaskModal';
import Modal from '../AlertModal/Modal';

const tabStatusMap = {
    // 'request': 'NEW_REQUEST',
    'assigned': 'ASSIGNED',
    'accepted': 'ACCEPTED',
    'inprogress': 'IN_PROGRESS',
    'collected': 'COLLECTED',
    'handovered': 'HANDOVERED',
    'completed': 'COMPLETED',
    'rejected': 'REJECTED',
    'cancelled': 'CANCELLED',
};


// Helper to format date/time for display
const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
};

// Helper for priority badge
const PriorityBadge = ({ priority }) => (
    <span className={`px-2 py-0.5 ml-2 rounded-full text-xs font-semibold ${priority === 'HIGH' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
        }`}>
        {priority}
    </span>
);


// ----------------------------------------------------------------
// 2. MAIN DASHBOARD COMPONENT
// ----------------------------------------------------------------

function LogisticsTask({ allEmployees, tasks }) {
    const [allTasks, setAllTasks] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null);
    const [allEmployee, setAllEmployee] = useState([]);
    const [allOperations, setAllOperation] = useState([]);
    const [activeTab, setActiveTab] = useState('ASSIGNED');
    const [isLoading, setIsLoading] = useState(false);



    // const handleAssignAction = (task) => {
    //     setSelectedTask(task);
    //     setIsAssignModalOpen(true);
    // };

    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    // API Call to fetch ALL tasks
    const fetchTasks = useCallback(async () => {
        setIsLoading(true);
        const storedUser = localStorage.getItem('user');
        const userInfo = JSON.parse(storedUser)
        try {
            const response = await getAssignedTasks({ logisticId: userInfo.id });
            if (response.status === 1) {
                setAllTasks(response.data);

            } else {
                console.error("Failed to fetch tasks");
                setAllTasks([]);
            }
        } catch (error) {
            console.error("Network error fetching tasks:", error);
        } finally {
            setIsLoading(false);
        }

        try {
            const response = await getAllEmployees();
            if (response.status === 1) {
                setAllOperation(response.data.filter(item => item.userType == "OPERATION" && item.status == "ACTIVE"));
                setAllEmployee(response.data.filter(item => item.userType == "LOGISTIC" && item.status == "ACTIVE"));
            } else {
                console.error("Failed to fetch tasks");
                setAllEmployee([]);
            }
        } catch (error) {
            console.error("Network error fetching tasks:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);

    // Filtered data based on the active tab's status value
    const filteredTasks = allTasks.filter(task => task.status === tabStatusMap[activeTab]);

    // Function to handle tab clicks
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    // ----------------------------------------------------------------
    // TASK CARD COMPONENT
    // ----------------------------------------------------------------

    const TaskCard = ({ task, handleAction }) => {
        const timeSlot = task.slot ? `${task.slot.startTime.substring(0, 5)} - ${task.slot.endTime.substring(0, 5)}` : 'N/A';
        const creationTime = formatDateTime(task.createdAt);
        const isActionable = task.status === 'NEW_REQUEST';

        const PriorityBadge = ({ priority }) => {
            // Return null if no priority/status is provided to avoid rendering an empty badge
            if (!priority) {
                return null;
            }

            const statusText = priority.toUpperCase();
            let colorClass = '';

            // Determine the color class based on the status text
            switch (statusText) {
                case 'CANCELLED':
                case 'HIGH':
                    colorClass = 'bg-red-100 text-red-800';
                    break;
                case 'COMPLETED':
                    colorClass = 'bg-green-100 text-green-800';
                    break;
                case 'PENDING':
                case 'NORMAL':
                case 'MEDIUM':
                    colorClass = 'bg-yellow-100 text-yellow-800';
                    break;
                case 'LOW':
                    colorClass = 'bg-blue-100 text-blue-800';
                    break;
                default:
                    colorClass = 'bg-gray-100 text-gray-800';
                    break;
            }

            return (
                <span className={`mr-2 mb-1 px-2.5 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full ${colorClass}`}>
                    {statusText}
                </span>
            );
        };

        const storedUser = localStorage.getItem('user');
        const userInfo = JSON.parse(storedUser)

        const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
        const [selectedTaskId, setSelectedTaskId] = useState(null);

        const [operationUsers, setOperationUsers] = useState([]);

        const [taskToHandover, setTaskToHandover] = useState(null);



        const handleRejectClick = (taskId) => {
            setSelectedTaskId(taskId);
            setIsRejectModalOpen(true);
        };

        const handleRejectSubmit = async (data) => {
            // This is where you would trigger your data fetching/mutation
            await onRejectTask(data.taskId)
        };

        const onAcceptTask = async (id) => {
            const request = { remarks: "", status: "ACCEPTED", taskId: id }
            const result = await taskAccepted(request);

            if (result.status == 1) {
                // alert("Task Accepted Successfully!")
                showSuccess("Task Accepted Successfully!")
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                showError("Sorry!", "Something went wrong!")

            }
        }
        const onRejectTask = async (id) => {
            const request = { remarks: "", status: "REJECTED", taskId: id }
            const result = await taskReject(request);

            if (result.status == 1) {
                // alert("Task Rejected Successfully!")
                showSuccess("Task Rejected Successfully!")
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                showError("Sorry!", "Something went wrong!")

            }
        }

        const startLogisticTask = async (id) => {
            const request = {
                "taskId": id,
                "userId": userInfo.id
            }
            const result = await startTask(request);

            if (result.status == 1) {
                showSuccess("Task Started Successfully!")
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                // alert("Something went wrong!")
                showError("Sorry!", "Something went wrong!")

            }
        }

        const navigateToMap = async (task) => {
            console.log('navigate to map', task)
            // Ensure the task object and its coordinates are valid before proceeding.
            if (task && task.pickupClient.latitude && task.pickupClient.longitude) {
                const lat = task.pickupClient.latitude;
                const lng = task.pickupClient.longitude;

                // Standard URL format for Google Maps directions/search
                const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

                // Open the URL in a new browser tab
                window.open(url, '_blank', 'noopener,noreferrer');
            } else {
                // Provide feedback if location data is missing
                alert("Location coordinates are not available for this task.");
            }
        }
        const navigateToMap2 = async (task) => {
            console.log('navigate to map', task)
            // Ensure the task object and its coordinates are valid before proceeding.
            if (task && task.dropCentre.latitude && task.dropCentre.longitude) {
                const lat = task.dropCentre.latitude;
                const lng = task.dropCentre.longitude;

                // Standard URL format for Google Maps directions/search
                const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

                // Open the URL in a new browser tab
                window.open(url, '_blank', 'noopener,noreferrer');
            } else {
                // Provide feedback if location data is missing
                alert("Location coordinates are not available for this task.");
            }
        }

        // --- NEW STATE for the collection modal ---
        const [collectionTask, setCollectionTask] = useState(null);

        const handleOpenCollectionModal = (taskItem) => {
            setCollectionTask(taskItem);
        };

        // Resets the state to null, which closes the modal
        const handleCloseCollectionModal = () => {
            setCollectionTask(null);
        };

        // This function will receive the FormData from the modal and call the parent's API handler
        const handleCollectionSubmit = async (formData) => {
            // 'handleAction' is the prop passed from your main page component
            const result = await handleAction('collect', formData);
            // Close the modal only if the API call was successful
            if (result && result.success) {
                handleCloseCollectionModal();
            }
        };

        // ... inside your ParentComponent

        // Function to open the modal for a specific task
        const handleOpenModal = (task) => {
            setTaskToHandover(task);
        };

        // Function to close the modal
        const handleCloseModal = () => {
            setTaskToHandover(null);
        };

        // Function that will be passed to the modal to handle the API call
        const handleHandoverSubmit = async (payload) => {
            console.log("API Payload Ready:", payload);
            // --- YOUR API CALL LOGIC GOES HERE ---
            // const result = await handoverApi(payload);
            // if (result.success) {
            //   alert('Task handed over!');
            //   handleCloseModal(); // Close modal on success
            // }

            // For this example, we'll just log it and close the modal
            // alert(`Handing over Task ID: ${payload.taskId}`);
            showSuccess(`Handing over Task ID: ${payload.taskId}`);
            handleCloseModal();
        };

        // const handoverToOperation = async (id) => {
        //     const result = handoverTask({
        //         "taskId": id,
        //         "logisticUserId": 2,
        //         "operationUserId": 1
        //     })
        // }

        return (
            <div className="bg-white rounded-lg shadow-md p-2 md:p-3 mb-3 flex border border-gray-200 hover:shadow-lg transition duration-200">
                {/* Status/Icon Panel */}
                <div className="p-2 flex-grow flex items-center justify-center bg-green-500 text-white rounded-l-md text-xl font-bold">
                    {isActionable ? '🆕' : '✔️'}
                </div>

                {/* Text Content Panel */}
                <div className="flex-grow flex justify-between items-start pl-3 w-full justify-between md:items-center">
                    <div className="w-full">
                        {/* Top Bar (Task Type & Slot) */}
                        <div className="flex justify-between items-start border-b pb-2 mb-2 flex-wrap">
                            <p className="text-sm font-semibold text-gray-700 m-0">
                                {/* {task.taskType} */}
                                <span className='mr-2'>Pickup Request</span>
                                <PriorityBadge priority={task.priority} />
                                {task.status === "CANCELLED" && (
                                    <PriorityBadge priority={task.status} />
                                )}
                            </p>
                            <p className="text-sm font-medium text-green-600 m-0">{timeSlot}</p>
                        </div>

                        {/* Bottom Bar (Time, ID, Address/Client) */}
                        <div className="text-xs text-gray-600 space-y-1 flex-wrap">
                            <p className="text-xs font-semibold text-gray-700 mb-2">
                                Client Name: {task.pickupClient?.clientName}
                            </p>
                            <div className="flex justify-between items-center flex-wrap gap-1 md:gap-0">
                                <p className="text-xs m-0">
                                    <span className="font-semibold text-gray-500">Task ID:</span> {task.id}
                                </p>
                                <p className="text-xs text-gray-500 m-0">Created: {creationTime}</p>
                                {task.assignedTo && task.assignedUser && (
                                    <span className="font-semibold text-gray-500 m-0">Assign To: {task?.assignedUser?.employeeName}</span>
                                )}
                                {task.status == "HANDOVERED" && (
                                    <span className="font-semibold text-gray-500 m-0">Waiting for Confirmation...</span>
                                )}

                                {/* --- ACTION BUTTONS CONTAINER --- */}
                                <div className="flex items-center space-x-2">

                                    {/* Accept & Reject Buttons */}
                                    {task.status === "ASSIGNED" && (
                                        <>
                                            <button onClick={() => onAcceptTask(task.id)}
                                                type="button"
                                                className="text-white bg-green-600 hover:bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-xs px-3 py-1 transition duration-150 focus:outline-none"
                                            >
                                                Accept
                                            </button>
                                            <button onClick={() => handleRejectClick(task.id)}
                                                type="button"
                                                className="focus:outline-none text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-1 transition duration-150"
                                            >
                                                Reject
                                            </button>
                                        </>
                                    )}

                                    {/* --- NEW BUTTONS START HERE --- */}

                                    {/* Navigate Button: Not visible for NEW_REQUEST or ASSIGNED */}
                                    {/* Pickup Sample Button */}
                                    {!['NEW_REQUEST', 'COLLECTED', 'COMPLETED', 'ASSIGNED'].includes(task.status) && (
                                        <button
                                            onClick={() => navigateToMap(task)}
                                            type="button"
                                            // Added 'inline-flex' and 'items-center' for icon alignment
                                            className="inline-flex items-center text-white bg-green-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 transition duration-150"
                                        >
                                            {/* Navigation Icon SVG */}
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                            </svg>
                                            Track
                                        </button>
                                    )}

                                    {/* Drop Sample Button */}
                                    {task.status === "COLLECTED" && (
                                        <button
                                            onClick={() => navigateToMap2(task)}
                                            type="button"
                                            // Added 'inline-flex' and 'items-center' for icon alignment
                                            className="inline-flex items-center text-white bg-green-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 transition duration-150"
                                        >
                                            {/* Navigation Icon SVG */}
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                            </svg>
                                            Track
                                        </button>
                                    )}
                                    {task.status === "IN_PROGRESS" && (
                                        <button
                                            onClick={() => handleOpenCollectionModal(task)} // Add your navigation function here
                                            type="button"
                                            className="text-white bg-green-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 transition duration-150"
                                        >
                                            Collect
                                        </button>
                                    )}
                                    {task.status === "COLLECTED" && (
                                        <button
                                            onClick={() => handleOpenModal(task)} // Add your navigation function here
                                            type="button"
                                            className="text-white bg-green-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 transition duration-150"
                                        >
                                            Handover
                                        </button>
                                    )}

                                    {/* Start Button: Only visible for ACCEPTED status */}
                                    {task.status === "ACCEPTED" && (
                                        <button
                                            onClick={() => startLogisticTask(task.id)} // Add your start task function here
                                            type="button"
                                            className="text-white bg-emerald-600 hover:bg-emerald-700 focus:ring-4 focus:ring-emerald-300 font-medium rounded-lg text-xs px-3 py-2 transition duration-150"
                                        >
                                            Start
                                        </button>
                                    )}
                                    {/* --- NEW BUTTONS END HERE --- */}

                                </div>
                            </div>
                        </div>

                        {/* Cancel Reason */}
                        {task.status === "CANCELLED" && task.cancelReason && (
                            <p className="text-xs text-red-600 font-semibold mt-1">
                                Cancel Reason: {task.cancelReason}
                            </p>
                        )}
                    </div>

                    {/* Action Block */}
                    <div className="flex-shrink-0">
                        {isActionable ? (
                            <button

                                className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 text-sm rounded-md transition duration-150 shadow-md"
                            >
                                Assign Task
                            </button>
                        ) : (
                            <button onClick={() => setIsModalOpen1(true)} className="text-gray-500 hover:text-gray-700 p-1 rounded-full">
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                        )}
                    </div>
                    {
                        isModalOpen1 && (
                            <TaskViewModal
                                taskData={task}
                                isOpen={isModalOpen1}
                                onClose={() => setIsModalOpen1(false)}
                            />
                        )
                    }

                    <TaskRejectModal
                        isOpen={isRejectModalOpen}
                        onClose={() => setIsRejectModalOpen(false)}
                        taskId={selectedTaskId}
                        onSubmit={handleRejectSubmit}
                    />

                    {collectionTask && (
                        <TaskCollectionModal
                            isOpen={!!collectionTask}
                            onClose={handleCloseCollectionModal}
                            taskData={collectionTask}
                            onSubmit={handleCollectionSubmit}
                        />
                    )}

                    <HandoverTaskModal
                        isOpen={!!taskToHandover}
                        onClose={handleCloseModal}
                        taskData={taskToHandover}
                        operationUsers={allOperations}
                        onSubmit={handleHandoverSubmit}
                    />
                    {
                        isModalOpen && (
                            <Modal
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                title={modalConfig.title}
                                message={modalConfig.message}
                                type={modalConfig.type}
                            />
                        )
                    }
                </div>
            </div>
        );
    };


    // ----------------------------------------------------------------
    // JSX RETURN
    // ----------------------------------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="bg-gray-50">
            <div className="main-wrap">
                <div className="container">
                    <div className="title">
                        <h4>Task Dashboard</h4>
                    </div>

                    {/* Filter */}
                    <div className="mb-3">
                        <div className="rounded-lg shadow-sm overflow-hidden border border-gray-200">
                            <button
                                className="w-full flex justify-between shadow-none items-center px-4 py-3 font-medium text-gray-800 bg-white hover:bg-gray-100 focus:outline-none focus:ring"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <span>Filter</span>
                                <i
                                    className={`fa-solid fa-chevron-down ml-2 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                                        }`}
                                ></i>
                            </button>



                            <div
                                className={`overflow-hidden transition-all bg-white duration-300 ease-in-out ${isOpen ? "max-h-screen" : "max-h-0"
                                    }`}
                            >
                                <div className="p-3">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-3 gap-y-2">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
                                            <input type="date"
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Centre</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Centre A</option>
                                                <option>Centre B</option>
                                                <option>Centre C</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Client</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Client 1</option>
                                                <option>Client 2</option>
                                                <option>Client 3</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Client Group</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Group A</option>
                                                <option>Group B</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">District</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>District 1</option>
                                                <option>District 2</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Area</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Area 1</option>
                                                <option>Area 2</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="flex justify-end gap-2 mt-4">
                                        <button className="bg-blue-500 text-white font-sm py-2 px-3 rounded text-sm theme_btn">
                                            Apply Filter
                                        </button>
                                        {/* <button className="bg-blue-500 text-white font-sm py-2 px-3 rounded text-sm edit_btn">
                                            Edit
                                        </button>
                                        <button className="bg-blue-500 text-white font-sm py-2 px-3 rounded text-sm cancel_btn">
                                            Delete
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Filter */}

                    <div className="staus-tab bg-white rounded-lg shadow-xl p-3 md:p-3 border-t-4 border-green-600">

                        {/* Navigation Tabs */}
                        <ul className="flex flex-wrap border-b border-gray-200 mb-4">
                            {Object.keys(tabStatusMap).map(tabId => (
                                <li className="mr-0" key={tabId}>
                                    <button
                                        className={`px-2 py-2 text-sm font-medium rounded-t-lg transition duration-200 ${activeTab === tabId
                                            ? 'bg-white border-b-2 border-green-600 text-green-600 font-semibold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                                            }`}
                                        onClick={() => handleTabClick(tabId)}
                                        role="tab"
                                    >
                                        {tabId.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')}
                                    </button>
                                </li>
                            ))}
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content">
                            {isLoading ? (
                                <p className="text-center py-8 text-green-600 font-medium">Loading tasks from API...</p>
                            ) : (
                                // Render the content only for the active tab
                                <div className="task-list-container">
                                    <h5>
                                        {activeTab.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')} Tasks ({filteredTasks.length})
                                    </h5>

                                    <div className="task-main-wrap space-y-4">
                                        {filteredTasks.length > 0 ? (
                                            filteredTasks.map(task => (
                                                <TaskCard
                                                    showAlerts={{ showSuccess, showError }}
                                                    key={task.id}
                                                    task={task}
                                                // handleAction={handleAssignAction}
                                                />
                                            ))
                                        ) : (
                                            <p className="text-center py-8 text-gray-500">No tasks found with the status: {tabStatusMap[activeTab]}.</p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )


}

export default LogisticsTask;